import * as React from 'react';
import { connect } from 'react-redux';
import { BREADCRUMBS_REDUCER_NAME } from 'src/react/components/breadcrumbs/constants';
import Crumbs from 'src/react/components/breadcrumbs/components/Crumbs';
import reducer from 'src/react/components/breadcrumbs/reducers';
import State from 'src/react/components/breadcrumbs/types/State';
import { reducerRegistry } from '@collaborator/npm_modules/dist/components/redux';
import { FC } from 'react';

reducerRegistry.register(BREADCRUMBS_REDUCER_NAME, reducer);

const Breadcrumbs: FC<State> = ({ crumbs }) => (
  <nav aria-label="breadcrumb">
    <Crumbs crumbs={crumbs} />
  </nav>
);

const mapStateToProps = (state: {
  [BREADCRUMBS_REDUCER_NAME]: State,
}) => ({
  crumbs: state[BREADCRUMBS_REDUCER_NAME].crumbs,
});

export default connect(mapStateToProps)(Breadcrumbs);
